import React from 'react';

function YMContainer({ children, className }: any) {
  return <div className={`ym-container ${className}`}>{children}</div>;
}

export default YMContainer;
